var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1837_6554)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#116062",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24.6667L32.5 24.6667M32.5 24.6667C32.5 26.0474 33.6193 27.1667 35 27.1667C36.3807 27.1667 37.5 26.0474 37.5 24.6667C37.5 23.286 36.3807 22.1667 35 22.1667C33.6193 22.1667 32.5 23.286 32.5 24.6667ZM27.5 31.3333L37.5 31.3333M27.5 31.3333C27.5 32.714 26.3807 33.8333 25 33.8333C23.6193 33.8333 22.5 32.714 22.5 31.3333C22.5 29.9526 23.6193 28.8333 25 28.8333C26.3807 28.8333 27.5 29.9526 27.5 31.3333Z",
    stroke: "#0E4D4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1837_6554",
    x: 0.6,
    y: 0.6,
    width: 58.8,
    height: 58.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133264 0 0 0 0 0.351817 0 0 0 0 0.420833 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1837_6554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1837_6554",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.7ef8378cdcc5a1d92870b5a96ce8a91e.svg";
export { ForwardRef as ReactComponent };